import { AliasParams } from '@de/types';

type AliasSet = {
  anonymousId?: string;
  instanceId?: string;
  sessionId?: string;
  tenantId?: string;
  transitId?: string;
};

/**
 * Reads the live Tagular alias-set via `window.tagular('getAliasSet')`.
 *
 * Used as a defensive fallback when the inbound URL doesn't carry the
 * `ref_*` / `transit_id` family (e.g. direct-entry traffic). Callers
 * should consult URL params first and only fall back to this helper
 * when the URL is silent.
 *
 * @return {AliasParams | undefined}
 * Returns `undefined` if Tagular is unavailable, the alias-set call
 * returns nothing, or the call throws.
 */
const getAliasParams = (): AliasParams | undefined => {
  if (typeof window === 'undefined' || typeof window?.tagular !== 'function') {
    return undefined;
  }

  try {
    const aliasSet = window?.tagular('getAliasSet');

    if (!aliasSet) {
      return;
    }

    const { anonymousId, instanceId, sessionId, tenantId, transitId } =
      aliasSet as AliasSet;

    return {
      ref_anon: anonymousId ?? '',
      ref_inst: instanceId ?? '',
      ref_sess: sessionId ?? '',
      ref_tenant: tenantId ?? '',
      transit_id: transitId ?? '',
    };
  } catch {
    return;
  }
};

export default getAliasParams;
